import React from 'react'
import styled from 'styled-components'

const About = styled.div`
    background: url(${props => props.image});
    height: 600px;
    background-size: cover;
    background-position: center;
    position: relative;

    @media (max-width: 640px) {
        height: 510px;
    }
`

const AboutGroup = styled.div`
    margin: 0 auto;
    max-width: 600px;
    padding: 100px 0;
    text-align: center;
`

const AboutTitle = styled.h1`
    margin: 0;
    color: white;
    font-size: 60px;
    line-height: 1.2;
    opacity: 0;
    animation: HeroAnimation;
    animation-duration: 3s;
    animation-delay: 0.1s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

    @media (max-width: 640px) {
        font-size: 40px;
    }
`

const AboutSubtitle = styled.h2`
    margin: 0;
    color: white;
    font-size: 30px;
    line-height: 1.2;
    font-weight: 400;
    opacity: 0;
    animation: HeroAnimation;
    animation-duration: 3s;
    animation-delay: 0.2s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

    @media (max-width: 640px) {
        font-size: 24px;
    }
`

const AboutParagraph = styled.p`
    padding: 20px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 30px;
    font-weight: 500;
    line-height: 1.5;
    max-width: 600px;
    opacity: 0;
    animation: HeroAnimation;
    animation-duration: 3s;
    animation-delay: 0.3s;
    animation-fill-mode: forwards;
    animation-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);

    @media (max-width: 640px) {
        font-size: 24px;
    }
`

const AboutSVG = styled.svg`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

`

const AboutImage = styled.img`
  width: 200px;

  @media (max-width: 640px) {
    width: 140px;
  }
`

const AboutComponent = props => (
    <About image={props.image}>
        <AboutGroup>
            <AboutTitle>{props.title}</AboutTitle>
            <AboutParagraph>{props.text}</AboutParagraph>
        </AboutGroup>
        <AboutSVG>
            <svg height="200">
                <path fill="rgba(255,255,255,0.5)">
                    <animate repeatCount="indefinite" fill="freeze" attributeName="d" dur="6s" values="M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z;
                        M0 53.6584C158 11.0001 213 0 363 0C513 0 855.555 115.001 1154 115.001C1440 115.001 1626 -38.0004 2560 53.6585V199.66L0 199.66V53.6584Z;
                        M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z" />
                </path>
            </svg>
        <svg height="172">
            <path fill="rgba(255,255,255,1.0)">
                <animate repeatCount="indefinite" fill="freeze" attributeName="d" dur="10s" values="M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z;
                    M0 53.6584C158 11.0001 213 0 363 0C513 0 855.555 115.001 1154 115.001C1440 115.001 1626 -38.0004 2560 53.6585V199.66L0 199.66V53.6584Z;
                    M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z" />
            </path>
        </svg>
        </AboutSVG>
    </About>
)

export default AboutComponent